<template>
<div class="chapter">
<div class="inner_page">
<h1 class="chapter1">Two</h1>
<p class="noindent">The guy was pretty helpful keeping Mark posted on the whereabouts of his wife. He'd call every other day or so to let Mark know if she was going anywhere special. Usually she just went to the mall or to the market for groceries, but one night he called all in a panic saying he was sure tonight was going to be the night.</p>
<p class="p1">Mark thanked him and called his wife Julie to let her know he'd be working late.</p>
<p class="p1">"That's fine, Mark," she said.</p>
<p class="p1">"Really?" Julie usually wasn't too happy about his working nights, and had asked him on more than one occasion if he were having an affair. Mark knew he spent too many nights away from her when he was working, but it was the nature of his business.</p>
<p class="p1">What else could he do?</p>
<p class="p1">But instead of putting up a stink like she usually did, Julie had simply said, "I'll be home late tonight too."</p>
<p class="p1">Mark didn't like to pry into his wife's affairs since it would suggest that he didn't trust her, but this time he was too curious to let it slide. It was just so unlike her to be pleasant about his not being home in the evening. "Working late?"</p>
<p class="p1">"No, just meeting a friend."</p>
<p class="p1">"Girl's night out, eh?"</p>
<p class="p1">"Yeah, sort of."</p>
<p class="p1">"Okay. Well, enjoy yourself," Mark said. "And I'll see you when I get in."</p>
<p class="p1">"When will that be?" she asked.</p>
<p class="p1">Now this seemed more like it. But Mark had learned long ago never to give her a definite time because she would use it against him if he were later than he'd said he would be. "As soon as the job's over, hon."</p>
<p class="p1">"Okay," she said. "See you then."</p>
<p class="p1">Mark hung up the phone thinking it had all gone a little too smoothly. Something hadn't been right about that exchange, but what?<br style="clear:both;"/></p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter12.vue?05dae1c2